
<div id='container'>
    <h4 mat-dialog-title *ngIf="data.rapidScore">{{'TERMS.MODAL.TITLE' | translate}}</h4>
<div mat-dialog-content>
    <p>{{text}}</p>
</div>
<div mat-dialog-actions class="btn-container">
    <button type="submit" (click)="goToUrl()" class="button" [ngClass]="{'rapidScore': data.rapidScore}">{{'TERMS.BUTTONS.CONTINUE' | translate}}</button>
</div>
</div>